import { addNavMenuItem } from '@vendure/admin-ui/core';

export default [
    addNavMenuItem(
        {
            id: 'pos-orders',
            label: 'POS Orders',
            routerLink: ['/extensions/sales/pos-orders'],
            icon: 'shopping-cart',
        },
        'sales',
    ),
];
